'use client';

import { useRef, useMemo } from 'react';
import { useScroll } from 'framer-motion';

// ----------------------------------------------------------------------

/** `'document'`(기본)는 창 전체를, `'container'` 는 `elementRef` 가 붙은 요소를 잰다 */
export type ScrollProgressTarget = 'document' | 'container';

export function useScrollProgress(target: ScrollProgressTarget = 'document') {
  const elementRef = useRef<HTMLDivElement>(null);

  const options = { container: elementRef };

  const { scrollYProgress, scrollXProgress } = useScroll(
    target === 'container' ? options : undefined
  );

  const memoizedValue = useMemo(
    () => ({ elementRef, scrollXProgress, scrollYProgress }),
    [elementRef, scrollXProgress, scrollYProgress]
  );

  return memoizedValue;
}
